import { get, post, del, put } from '@api/request';

export const fetchDefinitions = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/workitemdefinitions`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addDefinition = async (
  { queueService },
  authenticationToken,
  payload,
) => {
  const url = `${queueService}/queue/workitemdefinitions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateDefinition = async (
  { queueService },
  authenticationToken,
  { definitionID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteDefinition = async (
  { queueService },
  authenticationToken,
  { definitionID },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchDefinition = async (
  { queueService },
  authenticationToken,
  { definitionID },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSubtypes = async (
  { queueService },
  authenticationToken,
  { definitionID },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}/subtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addSubtype = async (
  { queueService },
  authenticationToken,
  { definitionID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}/subtypes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateSubtype = async (
  { queueService },
  authenticationToken,
  { subTypeID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/subtype/${subTypeID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteSubtype = async (
  { queueService },
  authenticationToken,
  { subTypeID },
) => {
  const url = `${queueService}/queue/workitemdefinition/subtype/${subTypeID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchSubtype = async (
  { queueService },
  authenticationToken,
  { subTypeID },
) => {
  const url = `${queueService}/queue/workitemdefinition/subtype/${subTypeID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchStatuses = async (
  { queueService },
  authenticationToken,
  { definitionID },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}/statuses`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addStatus = async (
  { queueService },
  authenticationToken,
  { definitionID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/${definitionID}/statuses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteStatus = async (
  { queueService },
  authenticationToken,
  { statusID },
) => {
  const url = `${queueService}/queue/workitemdefinition/status/${statusID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchStatus = async (
  { queueService },
  authenticationToken,
  { statusID },
) => {
  const url = `${queueService}/queue/workitemdefinition/status/${statusID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateStatus = async (
  { queueService },
  authenticationToken,
  { statusID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/status/${statusID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchWorkTypesSubTypes = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/workitemdefinitiontypesubtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchWorkTypesSubTypesStatuses = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/workitemdefintiontypessubtypesstatuses`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const setDefaultWorkType = async (
  { queueService },
  authenticationToken,
  { statusID },
) => {
  const url = `${queueService}/queue/workitemdefinition/status/${statusID}/setdefault`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const setStatusVisibility = async (
  { queueService },
  authenticationToken,
  { statusID, payload },
) => {
  const url = `${queueService}/queue/workitemdefinition/status/${statusID}/setactive`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};
